export default "__VITE_ASSET__BzKJ9K$Y__"